export var EventTypes;
(function (EventTypes) {
    EventTypes["BUTTON_CLICKED"] = "buttonClicked";
    EventTypes["IMPRESSION"] = "cruImpression";
    EventTypes["VIEWED"] = "cruViewed";
    EventTypes["ADD_TO_CART"] = "confirmedAddToCart";
    EventTypes["WIDGET_CLOSE"] = "widget_close";
})(EventTypes || (EventTypes = {}));
export var PolarisTelemetryEventTypes;
(function (PolarisTelemetryEventTypes) {
    PolarisTelemetryEventTypes["IMPRESSION"] = "impression";
    PolarisTelemetryEventTypes["VIEWED"] = "viewed";
    PolarisTelemetryEventTypes["CLICKED"] = "clicked";
    PolarisTelemetryEventTypes["COMPONENT_VIEWED"] = "componentViewed";
})(PolarisTelemetryEventTypes || (PolarisTelemetryEventTypes = {}));
export var PolarisTelemetryClickTypes;
(function (PolarisTelemetryClickTypes) {
    PolarisTelemetryClickTypes["CLICK"] = "clickThru";
    PolarisTelemetryClickTypes["EVENT"] = "event";
    PolarisTelemetryClickTypes["CAROUSEL"] = "carouselInteraction";
})(PolarisTelemetryClickTypes || (PolarisTelemetryClickTypes = {}));
